import React, { FC } from 'react'

import Box from '@mui/material/Box'

import {
	CoachOverviewHeadInfoBox,
	CoachOverviewHeadInfoName,
	CoachinitialPswdLeftBlock,
} from './styled'
import { User } from '../../../../../../types/user'
import CoachActivateButton from './CoachActivateButton'
import CoachOverviewInitialPswd from './CoachOverviewInitialPswd'
import { useTypedSelector } from '../../../../../../hooks/useTypedSelector'
import { selectSelectedCoach } from '../../../../../../store/reducers/coaches/selectors'
import AppUserActiveStatus from '../../../../../../components/AppUserActiveStatus/AppUserActiveStatus'

interface CoachOverviewHeadInfoProps {
	readonly uploadsSlot?: React.ReactNode
}

const CoachOverviewHeadInfo: FC<CoachOverviewHeadInfoProps> = ({
	uploadsSlot,
}: CoachOverviewHeadInfoProps) => {
	const coach: User = useTypedSelector(selectSelectedCoach)
	const active = coach?.extra?.active
	const firstPswd = coach?.extra?.firstPassword || ''
	const firstLogin = !!coach.extra?.firstLogin

	if (!coach._id) return null

	return (
		<CoachOverviewHeadInfoBox showInitialPswd={!!(firstPswd && firstLogin)}>
			<CoachinitialPswdLeftBlock>
				{uploadsSlot}

				<Box>
					<CoachOverviewHeadInfoName maxRows={1} variant={'h2'}>
						{`Coach ${coach?.personal?.name || ''}`}
					</CoachOverviewHeadInfoName>

					{!active && (
						<AppUserActiveStatus
							status={'inactive'}
							wrapperSx={{ mt: 1.5 }}
						/>
					)}
				</Box>
			</CoachinitialPswdLeftBlock>

			{firstPswd && firstLogin && (
				<CoachOverviewInitialPswd initialPswd={firstPswd} />
			)}

			<CoachActivateButton coachId={coach._id} isActive={active} />
		</CoachOverviewHeadInfoBox>
	)
}

export default CoachOverviewHeadInfo
